import React from 'react';
import cx from 'classnames';
import { BreadcrumbsProps } from './Breadcrumbs.types';
import styles from './Breadcrumbs.module.scss';
import { Icon } from '../../atoms';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import Breadcrumb from './Breadcrumb/Breadcrumb';
import RepeaterList from '../List/RepeaterList';

// Extract all Breadcrumb components, flattening one level deep
const extractBreadcrumbs = (children: React.ReactNode): React.ReactNode[] => {
  const result: React.ReactNode[] = [];
  React.Children.forEach(children, child => {
    if (React.isValidElement(child)) {
      if (child.type === Breadcrumb) {
        result.push(child);
      } else if (child.type === RepeaterList) {
        // Extract Breadcrumb items from RepeaterList by manually rendering its output
        const { data, component: Component } = child.props;
        data?.forEach((item: any, index: number) => {
          if (Component === Breadcrumb) {
            result.push(<Component key={index} {...item} />);
          }
        });
      } else if (child.type === React.Fragment && child.props.children) {
        // Handle fragments - go one level deep
        React.Children.forEach(child.props.children, nestedChild => {
          if (React.isValidElement(nestedChild) && nestedChild.type === Breadcrumb) {
            result.push(nestedChild);
          }
        });
      }
    }
  });
  return result;
};

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { className, children, divider } = props;

  const items = extractBreadcrumbs(children);

  const dividerComponent = divider ||
    <Icon className={styles.divider} icon='ArrowForward' style='Outlined' size='Medium' />;

  const variantProps = useBuildVariantProps(
    'breadcrumbs',
    {},
    {},
  );

  return (
    <ol
      className={cx(styles.breadcrumbs, className)}
      {...variantProps}
    >
      {items.map((child, index) => (
        <li key={index} className={styles.breadcrumbItem}>
          {child}
          {index < items.length - 1 && dividerComponent}
        </li>
      ))}
    </ol>
  );
};

export default Breadcrumbs;